import React, { useContext } from 'react';

export const MaintenanceModeContext = React.createContext<{
  activateMaintenanceMode: () => void;
}>({ activateMaintenanceMode: () => {} });

export const useMaintenanceMode = () => {
  return useContext(MaintenanceModeContext);
};
